module.exports = __webpack_public_path__ + "static/media/creator_list_image.26bc1f76.svg";